<!--
     <CentroList
       :centros="centros"
       @action_new="action_new"
       @action_edit="action_edit"
       @action_delete="action_delete"
     />
-->

<template>
  <div class="ca-layout">
    <div class="ca-sub-header cl-mod-header">
      <v-text-field
        style="max-width: 320px"
        v-model="filter_centro"
        dense filled outlined clearable color="primary"
        label="Buscar centro"
      />
    </div>

    <div v-if="centro_list.length < 1">
      No existe ningún centro.
    </div>

    <v-data-table
      :headers="headers"
      :items="centro_list"
      :items-per-page="500"
      style="width: 100%"
      :sort-by.sync="sort_by"
      :sort-desc.sync="sort_desc"
      dense
    >
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="action_edit(item.id)">
          mdi-pencil
        </v-icon>
        <v-icon small class="mr-2" @click="action_new(item.id)">
          mdi-plus
        </v-icon>
        <v-icon small class="mr-2" @click="action_delete(item.id)" :disabled="has_child(item.id)">
          mdi-trash-can-outline
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<style lang="scss">
 @import "@/sass/centroadmin.scss";

 .cl-mod-header {
   justify-content: flex-end;
 }
</style>

<script>
 import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
 import QCentro from '@/api/QCentro';

 export default {
   name: 'CentroList',

   components: {
     
   },

   props: {
     centros: {required: true},
   },

   data: () => ({
     sort_by: 'path_str',
     sort_desc: false,
     filter_centro: '',
   }),

   computed: {
     ...mapGetters(['site_id']),

     headers() {
       return [
         {
           text: 'Path',
           sortable: true,
           value: 'path_str',
         },
         {
           text: 'Name',
           align: 'start',
           sortable: true,
           value: 'name',
         },
         {
           text: 'Url name',
           sortable: true,
           value: 'url_name',
         },
         {
           text: 'Id',
           align: 'start',
           sortable: true,
           value: 'id',
         },
         {
           text: '',
           sortable: false,
           value: 'actions',
         },
       ];
     },

     centro_list() {
       const search = (this.filter_centro || '').toLowerCase();
       return (
         (Object.values(this.centros) || [])
           .filter(c => !search || c.path_str.toLowerCase().indexOf(search) >= 0)
       );
     },
   },

   methods: {
    has_child(centro_id) {
      return !!(Object.values(this.centros) || []).find(centro => centro.parent == centro_id);
    },
     action_new(cid) {
       this.$emit('action_new', cid);
     },

     action_edit(cid) {
       this.$emit('action_edit', cid);
     },

     action_delete(cid) {
       this.$emit('action_delete', cid);
     },
   },

   mounted() {
     // Query
   },
 }
</script>
